<a [href]="skipLinkPath" class="visually-hidden focusable skip-link">Skip to main content</a>